module.exports = __webpack_public_path__ + "static/media/spradling_logo.fe5884af.svg";